// extracted by mini-css-extract-plugin
export default {"wrapper":"Games_wrapper__lT4wd","content":"Games_content__Dcg-u","mobileWrapper":"Games_mobileWrapper__hy1tu","mobileContent":"Games_mobileContent__McW+S"};